module.exports = __webpack_public_path__ + "img/account-m.23fd4ab6.png";